import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { MOCK_IMPORT_SERVICES } from "./project-mock-data";

// The four import tiles, used both while creating a Project and later inside
// it. One implementation, two callsites - the tiles carry their own "not
// linked" toast, so a caller only decides where they sit.
//
// Prototype placeholders only: no vendor connection or import is implemented.
// The missing availability badge and brand-colour exception remain open design
// work; this component does not establish a new design-system rule.

export function ProjectImportTiles() {
  const intl = useIntl();
  const [hint, setHint] = useState<string | null>(null);

  useEffect(() => {
    if (!hint) return;
    const t = setTimeout(() => setHint(null), 2200);
    return () => clearTimeout(t);
  }, [hint]);

  return (
    <>
      <div className="grid grid-cols-2 gap-3 @sm:grid-cols-4">
        {MOCK_IMPORT_SERVICES.map((svc) => (
          <button
            key={svc.id}
            type="button"
            className="box-button flex h-full min-h-[110px] w-full flex-col p-4 text-left transition hover:-translate-y-0.5"
            onClick={() =>
              setHint(
                intl.formatMessage(
                  { id: "project.import.notLinked", defaultMessage: "{service} ist aktuell nicht verlinkt" },
                  { service: intl.formatMessage(svc.title) },
                ),
              )
            }
          >
            <div
              className="flex h-7 w-7 items-center justify-center rounded-md text-smycles-micro font-bold text-white"
              style={{ backgroundColor: svc.color }}
            >
              {svc.icon}
            </div>
            <div className="smycles-field-value mt-3 font-medium">{intl.formatMessage(svc.title)}</div>
            <div className="smycles-field-meta mt-1 leading-snug text-ink">{intl.formatMessage(svc.desc)}</div>
          </button>
        ))}
      </div>

      {hint ? (
        <div
          role="status"
          className="fixed bottom-4 left-1/2 z-[var(--z-toast)] w-[26rem] max-w-[calc(100vw-2rem)] -translate-x-1/2 sm:bottom-8"
        >
          <div className="smycles-toast">
            <span className="flex min-h-6 min-w-0 flex-1 items-center">{hint}</span>
          </div>
        </div>
      ) : null}
    </>
  );
}
